import instance from './API'

export function getJdHistory(
  token,
  userID,
  start,
  end,
  start_col,
  start_val,
  user_filter,
  isCompleteJD = 0,
) {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
      'Content-Type': 'application/json',
    },
    params: {
      uuid: userID,
      offset: start,
      limit: end,
      start_col,
      start_val,
      isCompleteJD,
      user_filter,
    },
  }
  return instance.get('campaigns/history/', config)
}
// Get Incomplete campaigns
export function getJdHistoryInComplete(
  token,
  start,
  end,
  zone,
  startDate,
  endDate,
) {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
      'Content-Type': 'application/json',
    },
    params: {
      offset: start,
      limit: end,
      zone,
      startDate,
      endDate,
    },
  }
  return instance.get('campaigns/history/incomplete/', config)
}

// Get Completed campaigns
export function getJdHistoryCompleted(
  token,
  userID,
  start,
  end,
  contractType,
  fulltimeType,
  zone,
  startDate,
  endDate,
) {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
      'Content-Type': 'application/json',
    },
    params: {
      uuid: userID,
      offset: start,
      limit: end,
      jd_type_contract: contractType,
      jd_type_fulltime: fulltimeType,
      zone,
      startDate,
      endDate,
    },
  }
  return instance.get('campaigns/history/complete/', config)
}

//get All campaigns
export function getJdsForTask() {
  return instance.get('extension/campaigns/', {})
}

//get JD Task Summary
export function getJdTasks(token, userID) {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
      'Content-Type': 'application/json',
    },
    params: {
      id: userID,
      offset: 0,
      limit: 100,
    },
  }
  return instance.get('campaigns/tasks/', config)
}

//Update JD Task Summary
export function updateJDTask(token, taskId, accountType) {
  const formData = new FormData()
  formData.append('taskID', taskId)
  formData.append('account_type', accountType)

  const config = {
    headers: {
      Authorization: `Token ${token}`,
      'Content-Type': 'application/json',
    },
    /*params: {
            taskID: taskId,
            account_type: accountType
        }*/
  }
  return instance.put('campaigns/tasks/', formData, config)
}

//get JD Task Details
export function getJdTaskDetails(token, taskId, start, end) {
  console.log('TASK ID ', taskId)
  const config = {
    headers: {
      Authorization: `Token ${token}`,
      'Content-Type': 'application/json',
    },
    params: {
      id: taskId,
      offset: start,
      limit: end,
    },
  }
  return instance.get('campaigns/tasks/details/', config)
}

//delete jdTaskDetails
export function deleteJDTaskDetails(token, id) {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
      'Content-Type': 'application/json',
    },
    data: {
      id,
    },
  }

  return instance.delete('campaigns/tasks/details/', config)
}

//get JD for selected Jdid
export function getJdChoosenTasks(
  token,
  campaign_id,
  offset,
  limit,
  sort_clause = 'n',
  sort_value = '',
  where_clause = '',
  where_value = '',
  start_col = '',
  start_val = '',
) {
  if (campaign_id === undefined) {
    return
  }
  const formData = new FormData()

  formData.append('campaign_id', campaign_id)
  formData.append('offset', offset)
  formData.append('limit', limit)
  formData.append('start_col', start_col)
  formData.append('start_val', start_val)
  formData.append('sort_clause', sort_clause)
  formData.append('sort_value', sort_value)
  formData.append('where_clause', where_clause)
  formData.append('where_value', where_value)

  const config = {
    headers: {
      Authorization: `Token ${token}`,
      'Content-Type': 'application/json',
    },
  }
  return instance.post('campaigns/choosenTasks/', formData, config)
}

export function getWAChooseTasks(
  token,
  campaign_id,
  offset,
  limit,
  sort_clause = 'n',
  sort_value = '',
  where_clause = '',
  where_value = '',
  start_col = '',
  start_val = '',
) {
  if (campaign_id === undefined) {
    return
  }
  const formData = new FormData()

  formData.append('campaign_id', campaign_id)
  formData.append('offset', offset)
  formData.append('limit', limit)
  formData.append('start_col', start_col)
  formData.append('start_val', start_val)
  formData.append('sort_clause', sort_clause)
  formData.append('sort_value', sort_value)
  formData.append('where_clause', where_clause)
  formData.append('where_value', where_value)

  const config = {
    headers: {
      Authorization: `Token ${token}`,
      'Content-Type': 'application/json',
    },
  }
  // Need to be Removed -- Changes in API
  return instance.post('campaigns/waChats/', formData, config)
}

// Save JdTasks and JdTaskDetails
export function saveJdTasks(
  token,
  campaign_id,
  taskName,
  accountType,
  totalProfiles,
  taskDetails,
  tags,
  template_id,
  subject,
) {
  const formData = new FormData()
  formData.append('campaign_id', campaign_id)
  formData.append('name', taskName)
  formData.append('accountType', accountType)
  formData.append('totalProfiles', totalProfiles)
  formData.append('taskDetails', JSON.stringify(taskDetails))
  formData.append('subject', subject)
  formData.append('template_id', template_id)
  formData.append('tags', tags)

  const config = {
    headers: {
      Authorization: `Token ${token}`,
      'Content-Type': 'application/json',
    },
  }
  return instance.post('campaigns/tasks/', formData, config)
}

// Add New campaigns
export function addNewJd(token, data, jdid) {
  const formData = new FormData()
  formData.append('data', JSON.stringify(data))
  formData.append('campaign_id', jdid)

  const config = {
    headers: {
      Authorization: `Token ${token}`,
      'Content-Type': 'application/json',
    },
  }
  console.log('FORM DATA ', JSON.stringify(data))
  console.log('FORM DATA1 ', formData)
  return instance.post('campaigns/tasks/new-campaign/', formData, config)
}

// Duplicate JdTasks
export function duplicateJdTasks(
  token,
  taskId,
  taskName,
  accountType,
  subject,
  template_id,
  tags,
) {
  const formData = new FormData()
  formData.append('taskID', taskId)
  formData.append('name', taskName)
  formData.append('account_type', accountType)
  formData.append('subject', subject)
  formData.append('template_id', template_id)
  formData.append('tags', tags)

  const config = {
    headers: {
      Authorization: `Token ${token}`,
      'Content-Type': 'application/json',
    },
  }
  return instance.put('campaigns/tasks/', formData, config)
}

export function getJdAnalytics(token, userID) {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
      'Content-Type': 'application/json',
    },
    params: {
      userID,
    },
  }

  return instance.get('campaign/analytics/', config)
}

export function deleteJD(token, campaign_id) {
  const formData = new FormData()
  formData.append('campaign_id', campaign_id)

  const config = {
    headers: {
      Authorization: `Token ${token}`,
      'Content-Type': 'application/json',
    },
  }

  return instance.post('jd/delete/', formData, config)
}

export function deleteJDTask(token, taskID) {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
      'Content-Type': 'application/json',
    },
    data: {
      taskID,
    },
  }

  return instance.delete('campaigns/tasks/', config)
}

// NOTIFCATION STARTS
export function getNotification(token, userID) {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
      'Content-Type': 'application/json',
    },
    params: {
      uuid: userID,
    },
  }

  return instance.get('notifications/', config)
}

export function markNotificationComplete(token, userID, nocID) {
  const formData = new FormData()
  formData.append('nocID', nocID)
  formData.append('uuid', userID)

  const config = {
    headers: {
      Authorization: `Token ${token}`,
      'Content-Type': 'application/json',
    },
  }

  return instance.post('notifications/', formData, config)
}

export function postNotification(token, from_user, to_user, message) {
  const formData = new FormData()
  formData.append('from_user', from_user)
  formData.append('to_user', to_user)
  formData.append('message', message)

  const config = {
    headers: {
      Authorization: `Token ${token}`,
      'Content-Type': 'application/json',
    },
  }

  return instance.put('notifications/', formData, config)
}

export function deleteNotification(token, userID, is_clear_all, nocID) {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
      'Content-Type': 'application/json',
    },
    data: {
      uuid: userID,
      is_clear_all,
      nocID,
    },
  }

  return instance.delete('notifications/', config)
}

// Notification Ends

export function getTargetData(token, userID, date) {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
      'Content-Type': 'application/json',
    },
    params: {
      to_userID: userID,
      date,
    },
  }

  return instance.get('user/target/', config)
}

export function postTargetData(
  token,
  from_user,
  to_user,
  target_value,
  question,
) {
  const formData = new FormData()
  formData.append('from_user', from_user)
  formData.append('to_user', to_user)
  formData.append('question', question)
  formData.append('target_value', target_value)

  const config = {
    headers: {
      Authorization: `Token ${token}`,
      'Content-Type': 'application/json',
    },
  }

  return instance.put('user/target/', formData, config)
}

export function getEmployeeData(token, emp_ids) {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
      'Content-Type': 'application/json',
    },
    params: {
      emp_ids,
    },
  }

  return instance.get('user/team/allmembers/', config)
}

export function getLinkedinGroupPost(campaign_id) {
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      campaign_id,
    },
  }

  return instance.get('campaign/post/linkedin/', config)
}

export function getBasicValidations(campaign_id, lead_id) {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      // Authorization: `Token ${token}`,
    },
    params: {
      campaign_id: campaign_id,
      lead_id: lead_id,
    },
  }

  return instance.get('extension/linkedin/v3/addtional_details/', config)
}
